var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('salary-statement-details',{key:_vm.$route.params.id,attrs:{"id":+_vm.$route.params.id,"default-date":_vm.defaultDate},on:{"dialog:close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }